<template>
  <div class="summary-section invoice-section">
    <b-row>
      <b-col>
        <h3 class="title-slash headings">
          {{ $t('invoices.single.info.title') }}
        </h3>
      </b-col>
      <b-col v-if="isIndian">
        <div class="d-flex justify-content-around float-md-right">
          <div class="help-text mr-4 text-uppercase">
            {{ $t('invoices.requestQuery.helpText') }}
          </div>
          <b-button
            variant="secondary"
            size="sm"
            @click.prevent="showRequestModal()"
            class="request-button p-2 mr-3 text-uppercase"
          >
            {{ $t('invoices.requestQuery.requestText') }}
          </b-button>
          <question-modal
            ref="question-modal"
            :key="questionKey"
            :invoice="invoice"
            :modal="modal"
            @request-success-modal="emitSuccessModal()"
          />
          <request-success-modal ref="requestSuccessModal" />
        </div>
      </b-col>
    </b-row>
    <div class="section tb-row">
      <b-row>
        <b-col :md="4" :cols="6" class="mb-3 mb-md-0">
          <div class="title pb-0 pb-md-1">
            {{ $t('invoices.add.form.buyer') }}
          </div>
          <div class="subtitle">{{ invoice.importer }}</div>
        </b-col>
        <b-col :md="4" :cols="6" class="mb-3 mb-md-0">
          <div class="title pb-0 pb-md-1">
            {{ $t('invoices.add.form.reference') }}
          </div>
          <div class="subtitle">{{ invoice.reference }}</div>
        </b-col>
        <b-col :md="4" :cols="6" class="mb-3 mb-md-0">
          <div class="title pb-0 pb-md-1">
            {{ $t('invoices.add.form.value') }}
          </div>
          <div class="subtitle">
            {{ invoice.value | currency(invoice.currsym) }}
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="section tb-row">
      <b-row>
        <b-col :md="4" :cols="6" class="mb-3 mb-md-0">
          <div class="title">{{ $t('invoices.add.form.container') }}</div>
          <div class="subtitle">{{ invoice.container || 'N/A' }}</div>
        </b-col>
        <b-col :md="4" :cols="6" class="mb-3 mb-md-0">
          <div class="title">{{ $t('invoices.add.form.blDate') }}</div>
          <div class="subtitle">{{ invoice.bl_date }}</div>
        </b-col>
      </b-row>
    </div>
    <div class="section tb-row">
      <b-row>
        <b-col>
          <div class="title">{{ $t('invoices.add.form.userDueDate') }}</div>
          <div class="subtitle">
            {{
              invoice.repayment ||
              invoice.user_due_date | formatDate('MMMM D, YYYY')
            }}
          </div>
        </b-col>
        <b-col>
          <div class="title">{{ $t('invoices.single.info.poNo') }}</div>
          <div class="subtitle" v-if="!!this.$store.state.account.accountId">
            {{ invoice.info.po_no || 'N/A' }}
          </div>
          <div class="subtitle" v-else>{{ invoice.po_no || 'N/A' }}</div>
        </b-col>
        <b-col>
          <div class="title">{{ $t('invoices.single.info.poDate') }}</div>
          <div class="subtitle">
            {{ (invoice.po_date || 'N/A') | formatDate('MMMM D, YYYY') }}
          </div>
        </b-col>
      </b-row>
    </div>
    <documents :invoice="invoice" />
  </div>
</template>
<script>
import Documents from '@/components/invoices/Details/v2/Documents'
import QuestionModal from '@/components/invoices/modals/QuestionModal'
import RequestSuccessModal from '@/components/invoices/modals/RequestSuccessModal'

export default {
  props: ['invoice'],
  data() {
    return {
      modal: false,
      questionKey: false
    }
  },
  methods: {
    showRequestModal() {
      this.modal = true
      this.$mpTrack('Raise request triggered')
      this.$refs['question-modal'].show()
    },
    emitSuccessModal() {
      this.questionKey = !this.questionKey
      this.modal = false
      this.$refs.requestSuccessModal.show()
    }
  },
  computed: {
    maxAdvance() {
      return this.invoice.value * (this.invoice.plan.advance_rate / 100)
    },
    setOff() {
      const customerNotes =
        (this.invoice &&
          this.invoice.form_data &&
          this.invoice.form_data.customer_notes) ||
        ''
      return customerNotes.includes('Invoices to be adjusted')
    },
    fundingType() {
      return this.setoff ? 'Fund New Invoice' : 'Adjust Against Existing'
    },
    isIndian() {
      return this.$store.state.account.country === 'India'
    }
  },
  components: {
    Documents,
    QuestionModal,
    RequestSuccessModal
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/variables';
.help-text {
  margin-top: 2rem;
  font-family: $lato;
  color: $dc-input-color;
  letter-spacing: 1.31px;
  font-size: 0.9rem;
}
.request-button {
  font-family: $montserrat;
  margin-top: 1.7rem;
  font-size: 0.8rem;
  font-weight: 500;
  border-radius: 7px;
}
</style>
